import { http } from '../../services/http';

export const getDimensions = () => {
  return dispatch => {
    http
      .get(`/furniture/data/dimensions`)
      .then(response => {
        dispatch({
          type: 'GET_DIMENSIONS_SUCCESS',
          data: response.data.result,
        });
        dispatch({
          type: 'GET_PRODUCT_TYPES_SUCCESS',
          data: response.data.result.types,
        });
        dispatch({
          type: 'GET_PRODUCT_DEFAULTS_SUCCESS',
          data: response.data.result.defaults,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_DIMENSIONS_ERROR', data: err });
      });
  };
};
